import React, { useState, useCallback, useEffect } from 'react';
import useLayoutEffect from '~app/hooks/useIsomorphicLayoutEffect';

const useCenterContainerOffset = (
  centerTarget: React.RefObject<HTMLElement> | undefined,
  viewportExclusions: number[],
  heightExclusions: number[],
  adjustment?: (margin: number) => number
): number => {
  const [offsetTop, setOffsetTop] = useState<number>(0);
  const calculateOffsetTop = useCallback(() => {
    const winH = window.innerHeight;
    const targetContainerHeight = (centerTarget?.current as HTMLElement)?.offsetHeight;
    const viewport = winH - viewportExclusions.reduce((a, i) => a + i, 0);
    const excludeHeight = heightExclusions.reduce((a, i) => a + i, 0);
    let margin = targetContainerHeight > 0 ? Math.max(10, viewport / 2 - targetContainerHeight / 2 - excludeHeight) : 0;

    margin = adjustment?.(margin) || margin;
    setOffsetTop(margin);
  }, [centerTarget, viewportExclusions, heightExclusions, adjustment]);

  useLayoutEffect(() => {
    window.addEventListener('resize', calculateOffsetTop);
    return () => window.removeEventListener('resize', calculateOffsetTop);
  }, [calculateOffsetTop]);

  useEffect(() => {
    calculateOffsetTop();
  }, [centerTarget, calculateOffsetTop]);

  return offsetTop;
};

export default useCenterContainerOffset;
